/* import external modules */
import React from 'react'
import { CircularProgress } from '@material-ui/core'

/* import internal modules */
import useStyles from './styles'

/**
 *  @description This  component is the generic loading with redux
 *  @version 1.0.0
 *  @since 16/09/2021
 *  @author Jaime Andrés Gómez Gutiérrez <jaime.gomez@teaminternational.com>
 *  @component
 *  @name Loading
 *  @returns {Component} Returns a generic loading
 *
 **/

const Loading = (props) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <CircularProgress color="primary" {...props} />
    </div>
  )
}

export default Loading
